import type { ReactNode } from 'react';
import { AlertIcon } from '../Icon.tsx';

/**
 * Çevrimdışı durum bandı.
 *
 * Tek bir ürün kalıbı: **ne oldu + kullanıcı ne yapabilir**. Hata kodları
 * kullanıcı metnine taşınmaz; yeniden deneme tek eylemdir.
 */
export function OfflineBanner({
  onRetry,
  savedAt = null,
}: {
  onRetry: () => void;
  savedAt?: number | null;
}): ReactNode {
  return (
    <div className="offline-banner" role="status">
      <span className="offline-banner__icon" aria-hidden="true">
        <AlertIcon size={18} />
      </span>
      <div className="offline-banner__text">
        <strong>Bağlantı yok · salt okunur</strong>
        <span>
          {savedAt === null
            ? 'Canlı katalog ve oynatma şu anda kullanılamıyor.'
            : `Son güncelleme: ${new Intl.DateTimeFormat('tr-TR', {
                dateStyle: 'short',
                timeStyle: 'short',
              }).format(new Date(savedAt))}. Oynatma çevrimdışı kullanılamaz.`}
        </span>
      </div>
      <button
        type="button"
        className="button button--ghost offline-banner__retry"
        onClick={onRetry}
      >
        Yeniden dene
      </button>
    </div>
  );
}
